import request from "./../utils/request";

export function getAdminUsers(perPage = 25, page = 1) {
    return request.get("/adminUsers/pagination", {
        params: {
            pageCount: page,
            perPage: perPage,
        },
    });
}

export function getAdminUser(id) {
    return request.get(`/adminUsers/adminUser/${id}`);
}

export function createAdminUser(data) {
    return request.post("/adminUsers/", data);
}

export function updateAdminUser(id, data) {
    return request.put(`/adminUsers/${id}`, data);
}

export function deleteAdminUser(id) {
    return request.delete(`/adminUsers/${id}`);
}
